<template>
    <div class="complaint--files">
        <div class="complaint--form-title">Reklamációhoz csatolt fájlok</div>
        <div class="complaint--form-datas">
            <div class="complaint--form-subtitle">
                Csatolt szállítólevelek
            </div>

            <ul>
                <li :key="id" v-for="(file, id) in files.delivery_note_files">
                    <a :href="file" target="_blank">
                        {{ getFileName(file) }}
                    </a>
                </li>
            </ul>

            <br>

            <div class="complaint--form-subtitle">
                Csatolt garancialevél
            </div>

            <ul>
                <li :key="id" v-for="(file, id) in files.warranty_file">
                    <a :href="file" target="_blank">
                        {{ getFileName(file) }}
                    </a>
                </li>
            </ul>

            <br>

            <div class="complaint--form-subtitle">
                Fotók a töréskárról/reklamációról
                <br>
                <small style="font-size:10px!important">Kattintson a képre hogy új lapon nyíljon meg!</small>
            </div>

            <ul>
                <li :key="id" v-for="(file, id) in files.photo_of_dmg_files">
                    <div v-if="isImage(file)">
                        <a target="_blank" :href="file">
                            <img :src="file" alt="Kép a töréskárról" class="damage-image" />
                        </a>
                    </div>
                    <div v-else>
                        <a :href="file" target="_blank">
                            {{ getFileName(file) }}
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "ComplaintFiles",
    props: {
        files: {
            type: Object,
            required: true
        }
    },
    methods: {
        isImage(file) {
            return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(file);
        },
        getFileName(file) {
            let name;
            if (file instanceof Object) {
                name = file.name.split('/').pop();
                return name.length > 30 ? name.substring(0, 30) + '...' : name;
            }

            if (file) {
                name = file.split('/').pop();
                return name.length > 30 ? name.substring(0, 30) + '...' : name;
            }

            return '-'
        }
    }
}
</script>

<style scoped>
.damage-image {
    max-width: 200px;
    height: auto;
    margin: 10px 0;
}
</style>
